import Admin from "./admin/Admin";
import Plans from "./Plan";
import Curso from "./admin/Cursos";
import CursosFuncion from "./admin/CursosFuncion";
import MapaCarrera from "./MapaCarrera";
import Competencies from "./admin/Competencias";
import CompetencyFun from "./admin/CompetenciasFuncion";
import MenuPlanCarrera from "./MenuPlanCarrera";
const PlanCarreraRouter = [
  {
    type: "private",
    path: "/plan-carrera/admin",
    roles: [
      "administrador",
      "Responsable_Carrera"
    ],
    component: Admin,
    exact: true,
  },
  
  {
    type: "private",
    path: "/plan-carrera/cursos",
    roles: [
      "administrador",
      "Responsable_Carrera"
    ],
    component: Curso,
    exact: true,
  },
  {
    type: "private",
    path: "/plan-carrera/planes",
    roles: [
      "administrador",
      "Responsable_Carrera"
    ],
    component: Plans,
    exact: true,
  },
  {
    type: "private",
    path: "/plan-carrera/cursos-funcion",
    roles: [
      "administrador",
      "Responsable_Carrera"
    ],
    component: CursosFuncion,
    exact: true,
  },
  {
    type: "private",
    path: "/plan-carrera/mapa",
    roles: [
      "administrador",
      "Responsable_Carrera"
    ],
    component: MapaCarrera,
    exact: true,
  },
  {
    type: "private",
    path: "/plan-carrera/competencias",
    roles: [
      "administrador",
      "Responsable_Carrera"
    ],
    component: Competencies,
    exact: true,
  },
  {
    type: "private",
    path: "/plan-carrera/competencias-funcion",
    roles: [
      "administrador",
      "Responsable_Carrera"
    ],
    component: CompetencyFun,
    exact: true,
  },
  {
    type: "private",
    path: "/plan-carrera/plan-de-carrera-individual/:planId/:codFuncion",
    roles: [
      "administrador",
      "Responsable_Carrera"
    ],
    component: MenuPlanCarrera,
    exact: false,
  }
];

export default PlanCarreraRouter;
